import React from "react";
import { Route, Routes } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

import { useRetrieveDocuments } from "@planzone/view-models";
import { DragAndDrop } from "@common/dragAndDrop";
import { SideBar } from "./sideBar";
import { ReportsPage } from "./reportsPage";
import { DocumentsPage as SubDocumentsPage } from "./documentsPage";
import { Props } from "./types";
import styles from "./styles.scss";

function DocumentsPage({ project }: Props) {
  const { t } = useTranslation();
  const {
    isRequestPending,
    isRequestSuccess,
    isRequestFailure,
    folder,
    retrieveDocuments,
  } = useRetrieveDocuments(project.uuid, "project");
  const sideBar = () => <SideBar project={project} documents={folder} />;

  React.useEffect(() => {
    !!project.uuid &&
      !isRequestPending &&
      !isRequestSuccess &&
      !isRequestFailure &&
      retrieveDocuments({ namespace: project.uuid, type: "project" });
  }, [project.uuid]);

  return (
    <DragAndDrop>
      <div className={styles.documentsPage}>
        <Helmet>
          <title>Planzone • {t("projectPage.documentsPage.title")}</title>
          <meta name="description" content={project.description} />
        </Helmet>
        <Routes>
          <Route
            path="reports"
            element={<ReportsPage project={project} sideBar={sideBar()} />}
          />
          <Route
            path="folders/:folderId"
            element={<SubDocumentsPage project={project} sideBar={sideBar()} />}
          />
          <Route
            path="*"
            element={<SubDocumentsPage project={project} sideBar={sideBar()} />}
          />
        </Routes>
      </div>
    </DragAndDrop>
  );
}

export { DocumentsPage };
